import { SearchItemOperator } from '@Types/api/common/filters';
import { TypeDict } from '@Types/index';
import { Mapper } from '@Features/utils/prepareSearchCriterias';
import { OptionNum } from '@Components/types/options';

import { FilterForm } from './types';

export const initialValues: FilterForm = {
  resignationDateFrom: '',
  resignationDateTo: '',
  lastWorkingDateFrom: '',
  lastWorkingDateTo: '',
  reason: [],
  statuses: [],
  letterOfContent: '',
};

export const filterTypes: Record<
  keyof typeof initialValues,
  SearchItemOperator
> = {
  resignationDateFrom: 'ge',
  resignationDateTo: 'le',
  lastWorkingDateFrom: 'ge',
  lastWorkingDateTo: 'le',
  reason: 'in',
  statuses: 'in',
  letterOfContent: 'like',
};

export const getFiltersMapper =
  (statuses: TypeDict[], reasonOptions: OptionNum[]): Mapper =>
  (key, value) => {
    if (key === 'resignationDateFrom') {
      return ['resDate', value];
    }

    if (key === 'resignationDateTo') {
      return ['resDate', value];
    }

    if (key === 'lastWorkingDateFrom') {
      return ['lastWrkngDate', value];
    }

    if (key === 'lastWorkingDateTo') {
      return ['lastWrkngDate', value];
    }

    if (key === 'reason') {
      const reasonCodes = (value as string[]).map(
        (item) => reasonOptions.find((option) => option.label === item)!.value
      );
      return ['reason', reasonCodes];
    }

    if (key === 'letterOfContent') {
      return ['letterContent', value];
    }

    const statusResultValue = (value as string[]).map(
      (item) => statuses.find((status) => status.codeDesc === item)!.codeNum
    );
    return ['statusId', statusResultValue];
  };
